export var AUTH_LOGIN = 'AUTH_LOGIN';
export var AUTH_CHECK = 'AUTH_CHECK';
export var AUTH_ERROR = 'AUTH_ERROR';
export var AUTH_LOGOUT = 'AUTH_LOGOUT';
export var AUTH_GET_PERMISSIONS = 'AUTH_GET_PERMISSIONS';